import React from 'react';
import { twMerge } from 'tailwind-merge';

interface EventProps {
  className?: string;
  width?: number;
  height?: number;
}

const EventIcon = function EventIcon({
  className,
  width,
  height,
}: EventProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <rect className={twMerge(className, 'fill-white')} x="3" y="6" width="18" height="15" rx="2" stroke="#222222" />
      <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#222222" />
      <path d="M7 3L7 6" stroke="#222222" strokeLinecap="round" />
      <path d="M17 3L17 6" stroke="#222222" strokeLinecap="round" />
      <path d="M11.7658 13.7924C11.971 13.2641 12.0736 13 12.25 13C12.4264 13 12.529 13.2641 12.7342 13.7924L12.7438 13.817C12.8597 14.1154 12.9176 14.2647 13.0358 14.3554C13.1539 14.4461 13.309 14.4604 13.6191 14.4891L13.6752 14.4943C14.1827 14.5412 14.4365 14.5647 14.4908 14.7314C14.5451 14.8982 14.3566 15.0753 13.9797 15.4294L13.8539 15.5476C13.6631 15.7269 13.5677 15.8165 13.5232 15.934C13.5149 15.9559 13.508 15.9784 13.5026 16.0012C13.4733 16.1237 13.5013 16.2538 13.5571 16.5138L13.5745 16.5948C13.6772 17.0728 13.7286 17.3118 13.6389 17.4149C13.6054 17.4534 13.5619 17.4811 13.5135 17.4947C13.3841 17.5312 13.2003 17.3766 12.8328 17.0673C12.5915 16.8642 12.4708 16.7627 12.3323 16.7398C12.2778 16.7308 12.2222 16.7308 12.1677 16.7398C12.0292 16.7627 11.9085 16.8642 11.6672 17.0673C11.2997 17.3766 11.1159 17.5312 10.9865 17.4947C10.9381 17.4811 10.8946 17.4534 10.8611 17.4149C10.7714 17.3118 10.8228 17.0728 10.9255 16.5948L10.9429 16.5138C10.9987 16.2538 11.0267 16.1237 10.9974 16.0012C10.992 15.9784 10.9851 15.9559 10.9768 15.934C10.9323 15.8165 10.8369 15.7269 10.6461 15.5476L10.5203 15.4294C10.1434 15.0753 9.95488 14.8982 10.0092 14.7314C10.0635 14.5647 10.3173 14.5412 10.8248 14.4943L10.8809 14.4891C11.191 14.4604 11.3461 14.4461 11.4642 14.3554C11.5824 14.2647 11.6403 14.1154 11.7562 13.817L11.7658 13.7924Z" fill="#222222" stroke="#222222" />
    </svg>
  );
};

EventIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default EventIcon;
